import styled from '@emotion/styled'

export const BottomActionsContainer = styled.div({
    display: "flex",
    justifyContent: "flex-end",
    margin: "0.625rem 0px 0.625rem auto",

    '>div:first-child':{
        flex:1
    }
});

export const PCondition = styled.div((props)=>{
    if(props.alert){
        return({
            '.MuiCard-root ':{
                border:'1px solid red'
            }
        })
    }else{
        return ({})
    }
});